import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';
import { Progress as ShadcnProgress } from '@/hen-ui/shadcn/progress';
import {
  ProgressFieldWrapper,
  type ProgressFieldWrapperProps,
} from './ProgressFieldWrapper';

export type ProgressProps = Omit<
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>,
  'max'
> &
  ProgressFieldWrapperProps;

export const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  ProgressProps
>(({ className, label, valueLabel, value, ...props }, ref) => {
  return (
    <ProgressFieldWrapper label={label} valueLabel={valueLabel}>
      <ShadcnProgress
        ref={ref}
        className='[&>div]:!bg-black h-2'
        value={value}
        max={100}
        {...props}
      />
    </ProgressFieldWrapper>
  );
});
Progress.displayName = 'Progress';
